Util = require 'app/scripts/lib/util'
{ Noun, Verb, trackUe } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
l = require 'app/scripts/lib/localize'
cardDetailToggleButtonTemplate = require 'app/scripts/views/templates/card_detail_toggle_button'

module.exports.convertToTemplate = (e) ->
  Util.stop(e)
  @model.update({ isTemplate: true })
  trackUe(Noun.CARD_TEMPLATES, Verb.SETS, Noun.IS_TEMPLATE, '', 'to template', '')
  Analytics.sendClickedButtonEvent
    buttonName: 'convertToTemplateButton'
    source: 'cardDetailScreen'
    container:
      board:
        id: @model.id
      organization:
        id: @model.get('idOrganization') || ''

module.exports.convertToCard = (e) ->
  Util.stop(e)
  @model.update({ isTemplate: false })
  trackUe(Noun.CARD_TEMPLATES, Verb.SETS, Noun.IS_TEMPLATE, '', 'to card', '')

module.exports.renderCardTemplate = ->
  $templateSidebar = @$('.js-template-sidebar-button')
  $addHeading = @$('.js-sidebar-add-heading')
  $archiveButtonText = @$('.js-archive-card .js-sidebar-action-text')
  $unarchiveButtonText = @$('.js-unarchive-card .js-sidebar-action-text')

  isTemplate = !!@model.get('isTemplate')

  $templateSidebar.next('.toggle-button').remove()
  if isTemplate
    $templateSidebar.after cardDetailToggleButtonTemplate(
      isOn: isTemplate
      text: 'template'
      title: 'convert-this-template-back-to-a-card'
      icon: 'template-card'
      selectorOn: 'js-convert-to-card'
      selectorOff: 'js-convert-to-template'
    )

    $addHeading.text l(['templates', 'card_detail', 'add-to-template'])
    $archiveButtonText.text l(['templates', 'card_detail', 'hide-from-list'])
    $archiveButtonText.attr('title', l(['templates', 'card_detail', 'hide-from-list']))
    $unarchiveButtonText.text l(['templates', 'card_detail', 'show-in-list'])
    $unarchiveButtonText.attr('title', l(['templates', 'card_detail', 'show-in-list']))
  else
    $addHeading.text l(['templates', 'card_detail', 'add-to-card'])
    $archiveButtonText.text l(['templates', 'card_detail', 'archive'])
    $archiveButtonText.attr('title', l(['templates', 'card_detail', 'archive']))
    $unarchiveButtonText.text l(['templates', 'card_detail', 'send-to-board'])
    $unarchiveButtonText.attr('title', l(['templates', 'card_detail', 'send-to-board']))

  @$('.js-convert-to-template').toggleClass('hide', isTemplate)

  $cardHeaderIcon = @$('.js-card-header-icon')
  $cardHeaderIcon.toggleClass('icon-card', !isTemplate)
  $cardHeaderIcon.toggleClass('icon-template-card', isTemplate)
  @$('.js-convert-to-template').toggleClass('hide', isTemplate)

  @

module.exports.isOnBoardTemplate = ->
  @model.isOnBoardTemplate()
